<template>
<div class="p-relative">
  <a v-if="workshop.acf.wanted" :href="workshop.acf.workshop_link" target="_blank" class="ws_squared d-block" :class="size === 'lg'? 'lg': 'sm'" :style="bgStyle">
    <div class="hover-layer d-flex justify-content-center align-items-center">
      <div class="border border-white px-3 py-2">予約フォーム</div>
    </div>
    <span class="bg-white border border-black px-2 py-1 text-body font-weight-bold">受付中</span>
  </a>
  <div v-else class="ws_squared" :class="size === 'lg'? 'lg': 'sm'" :style="bgStyle">
    <span class="bg-dark px-2 py-1 text-white font-weight-bold">終了</span>
  </div>
  <div class="opening-effect-cover-slide-right" :class="loaded? 'show':''"></div>
</div>
</template>

<script>

export default {
  name: 'WorkshopCell',
  props: {
    workshop: {
      type: Object,
      default: null
    },
    size: {
      type: String,
      default: 'sm'
    }
  },
  data() {
    return {
      mounteded: false,
      loaded: false,
    }
  },
  mounted() {
    this.mounteded = true
    setTimeout(() => {
      this.loading()
    }, 100);
  },
  computed: {
    bgStyle() {
      if (!this.workshop) {
        return {backgroundColor: '#333'}
      }
      if (this.loaded) {
        if (this.workshop._embedded) {
          return {backgroundImage: 'url(' + this.workshop._embedded['wp:featuredmedia'][0].source_url + ')'}
        } else {
          return {backgroundColor: '#333'}
        }
      }
      return {backgroundColor: '#333'}
    }
  },
  methods: {
    loading() {
      var image = document.createElement('img');
      if (this.workshop && this.workshop._embedded) {
        image.src = this.workshop._embedded['wp:featuredmedia'][0].source_url
      } else {
        image.src = '/images/img-alt.svg'
      }
      image.onload = () => {
        // console.log('onLoad!')
          this.loaded = true
      };
    },
    // openingEffect() {
    //   console.log('openingEffect!')
    //   this.isShown = true
    // }
  }
}
</script>
